// apps/client/src/components/broker-activity/MappingIncompleteBanner.tsx
//
// Shared interim info banner for the Broker Activity pages (Pipeline,
// Scorecard, Weekly Funnel). Per-adviser attribution + activity data are
// still populating because MyCRM adviser mapping is incomplete, so the
// figures on these pages reflect the full firm book and may be partial.
//
// Interim — remove once MyCRM adviser mapping is complete (tracked under
// #1193). Reuses the existing blue info-box style (mirrors the Weekly
// Funnel G6 caveat / Trail Leakage definition banners).

import React from 'react';
import { Info } from 'lucide-react';

export const MappingIncompleteBanner: React.FC = () => (
  <div
    role="note"
    aria-label="Adviser mapping in progress"
    className="rounded-md border border-blue-500/30 bg-blue-500/5 p-3 flex items-start gap-2 text-xs text-blue-200"
  >
    <Info className="w-4 h-4 mt-0.5 flex-shrink-0" aria-hidden="true" />
    <div className="leading-relaxed">
      Per-adviser attribution and activity data are still populating —
      MyCRM adviser mapping is not yet complete. Until it is, these figures
      reflect the <strong>full firm book</strong> and may be partial.
    </div>
  </div>
);

export default MappingIncompleteBanner;
